var _path, _g, _g2, _g3, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 38.814,
    viewBox: "0 0 30 38.814",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "doc",
    transform: "translate(-282.91 -1177.348)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_86_7",
    "data-name": "XMLID 86 7",
    opacity: 0.3,
    style: {
      isolation: "isolate"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2117",
    "data-name": "Path 2117",
    d: "M303.71,1177.348H284.859v38.814H312.91v-29.757Z",
    fill: "#5d5d5d"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_85_7",
    "data-name": "XMLID 85 7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2118",
    "data-name": "Path 2118",
    d: "M303.709,1177.348l9.2,9.068h-9.2Z",
    fill: "#5d5d5d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2045",
    "data-name": "Group 2045"
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_83_7",
    "data-name": "XMLID 83 7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2119",
    "data-name": "Path 2119",
    d: "M282.91,1208.825l1.941,1.647v-1.647Z",
    fill: "#fe9700"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_84_7",
    "data-name": "XMLID 84 7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1468",
    "data-name": "Rectangle 1468",
    width: 28,
    height: 13.286,
    transform: "translate(282.91 1195.54)",
    fill: "#fe9700"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2044",
    "data-name": "Group 2044",
    style: {
      isolation: "isolate"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2120",
    "data-name": "Path 2120",
    d: "M286.341,1205.95a.66.66,0,0,1,.468-1.128.606.606,0,0,1,.452.192.682.682,0,0,1,0,.936.609.609,0,0,1-.452.191A.64.64,0,0,1,286.341,1205.95Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2121",
    "data-name": "Path 2121",
    d: "M288.777,1201.573a2.618,2.618,0,0,1,.995-1.048,2.745,2.745,0,0,1,1.419-.372,2.631,2.631,0,0,1,1.267.314,2.265,2.265,0,0,1,.893.824v-3.085h.979v7.871h-.979v-1.095a2.262,2.262,0,0,1-.851.856,2.536,2.536,0,0,1-1.319.335,2.653,2.653,0,0,1-2.4-1.457,3.348,3.348,0,0,1-.361-1.575A3.272,3.272,0,0,1,288.777,1201.573Zm4.308.431a1.874,1.874,0,0,0-.718-.75,2.036,2.036,0,0,0-1.984-.006,1.857,1.857,0,0,0-.713.745,2.371,2.371,0,0,0-.265,1.148,2.426,2.426,0,0,0,.265,1.165,1.888,1.888,0,0,0,.713.756,1.927,1.927,0,0,0,.99.26,1.955,1.955,0,0,0,.994-.26,1.867,1.867,0,0,0,.718-.756,2.4,2.4,0,0,0,.266-1.154A2.371,2.371,0,0,0,293.085,1202Z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2122",
    "data-name": "Path 2122",
    d: "M297.068,1205.8a2.643,2.643,0,0,1-1.042-1.059,3.239,3.239,0,0,1-.378-1.59,3.146,3.146,0,0,1,.389-1.579,2.66,2.66,0,0,1,1.058-1.053,3.248,3.248,0,0,1,3,0,2.683,2.683,0,0,1,1.058,1.047,3.145,3.145,0,0,1,.388,1.585,3.1,3.1,0,0,1-.4,1.59,2.752,2.752,0,0,1-1.079,1.059,3.1,3.1,0,0,1-1.511.372A2.987,2.987,0,0,1,297.068,1205.8Zm2.463-.724a1.866,1.866,0,0,0,.739-.733,2.355,2.355,0,0,0,.282-1.192,2.378,2.378,0,0,0-.277-1.191,1.811,1.811,0,0,0-.723-.729,2.09,2.09,0,0,0-1.941,0,1.76,1.76,0,0,0-.708.729,2.466,2.466,0,0,0-.265,1.191,2.528,2.528,0,0,0,.26,1.2,1.737,1.737,0,0,0,.7.729,1.964,1.964,0,0,0,.957.239A2.038,2.038,0,0,0,299.531,1205.077Z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2123",
    "data-name": "Path 2123",
    d: "M302.86,1201.573a2.6,2.6,0,0,1,1.005-1.048,3.193,3.193,0,0,1,3.244.149,2.459,2.459,0,0,1,.921,1.446h-1.043a1.5,1.5,0,0,0-.579-.84,1.79,1.79,0,0,0-1.07-.309,1.713,1.713,0,0,0-1.34.57,2.331,2.331,0,0,0-.51,1.611,2.373,2.373,0,0,0,.51,1.628,1.706,1.706,0,0,0,1.34.574,1.806,1.806,0,0,0,1.064-.3,1.5,1.5,0,0,0,.585-.851h1.043a2.563,2.563,0,0,1-.936,1.431,2.8,2.8,0,0,1-1.756.537,2.89,2.89,0,0,1-1.473-.372,2.591,2.591,0,0,1-1.005-1.053,3.357,3.357,0,0,1-.361-1.6A3.3,3.3,0,0,1,302.86,1201.573Z",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoc);
export default __webpack_public_path__ + "static/media/doc.438d1ff41e1034bdc71a1ed2e906a88d.svg";
export { ForwardRef as ReactComponent };